import Navi from "../navi/Navi";
import Navi2 from "../navi/Navi2";

import Dashboard from "../root/Dashboard";
import "../root/app.css";
import Try from "../root/Try";
import ImgSlider from "../slider/ImgSlider";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import MovieDetail from "../movies/MovieDetail";
import WatchLater from "../watch-later/WatchLater";
import Categorized from "../categories/Categorized";
import React from 'react';

function App() {
  return (
    <Router>
      <div>
        {/* A <Switch> looks through its children <Route>s and
          renders the first one that matches the current URL. */}
        <Switch>


              {/* Category */}
          <Route path="/category">
              <Navi2 />
              <Categorized/>
          </Route>

          
           {/* Watch Later */}
          
           <Route path="/watch-later" className="categorized_part">
              <Navi2 />
              <WatchLater/>
          </Route>
          

        
          

          {/* Movie */}
          <Route path="/movie">
            <Navi2 />
            <div className="movie-detail">
              <MovieDetail />
            </div>
          </Route>
          
           {/* Home */}
          <Route path="/">
            <div id="app" className="App body">
              <div className="marvel">
                <Try></Try>
                <ImgSlider />
              </div>
              <Navi />
              <Dashboard />
            </div>
          </Route>




        </Switch>
      </div>
    </Router>
  );
}
export default App;
